import styled from "styled-components";

export const MintModalPhaseTwo = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`

export const OgInfo = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: center;
  gap: 0.75rem;
`

export const OgInfoRow = styled.div`
  display: flex;
  gap: 0.25rem;
  flex-direction: row;
  align-items: center;
  justify-content: start;
  font-family: BebasNeue;
  text-transform: uppercase;
  font-size: 1.25rem;
`

export const OgInfoLabel = styled.span`
  color: grey;
`

export const OgInfoValue = styled.span`
  color: ${({ theme, $selected }) => $selected ? theme.selection : 'white'};
`

export const OgSelector = styled.div`
  border-top: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  border-bottom: solid ${({ theme }) => theme.frameWidth} ${({ theme }) => theme.frame};
  position: relative;
  padding: 1.5rem;
  width: 100%;
  height: ${({ $height }) => $height ? $height : 'unset' };
  background-image: url(/assets/selector_bg.png);
  background-size: cover;
  max-height: ${({ $height }) => $height ? $height : '40vh' };
  overflow-y: auto;

  .selector-corner-tl {
    border-right: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    left: 0;
  }

  .selector-corner-tr {
    border-left: none;
    border-bottom: none;
    margin-top: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    top: 0;
    right: 0;
  }

  .selector-corner-br {
    border-left: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-right: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    right: 0;
  }

  .selector-corner-bl {
    border-right: none;
    border-top: none;
    margin-bottom: ${({ theme }) => '-' + theme.frameWidth};
    margin-left: ${({ theme }) => '-' + theme.frameWidth};
    bottom: 0;
    left: 0;
  }
`

export const OgHolder = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-items: start;
  align-items: center;
  gap: 10px;
  margin-bottom: 0.5rem;
  cursor: pointer;
  color: white;
  font-size: 30px; 

  &:hover {
    font-weight: 800;
  }

`
